import React, { useEffect } from 'react'
import { ImageLoader } from '@usap/uicomponents'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import SetKitDisplay from '../../../../../SetKitDisplay'
import QuantitySelection from '../../../../Forms/RMAReturnItemInfo/component/ItemDetail/QuatitySelection'
import { setQtyRange } from '../../../../Forms/RMAReturnItemInfo/utils'
import { LRItemSection } from '../../style/LifetimeReplacement.css'
import ItemDetailWmo from './ItemDetailWmo'

const ItemDetail = ({ item, handleQtyChange, orderDetails }) => {
  const {
    brandText,
    partNumber,
    parentSku,
    skuTitle,
    imageSrc,
    productText,
    qtyRange,
    itemPriceParsed,
    qtyToCompute,
    eligibleRMA,
  } = { ...item }

  const imageText = skuTitle || `${brandText} ${partNumber} ${productText}`

  useEffect(() => {
    handleQtyChange(1)
  }, [handleQtyChange])

  const isWmoEnabled = useWmoEnabled();
  if(isWmoEnabled){
    return (<ItemDetailWmo 
      item = {item}
      handleQtyChange = {handleQtyChange}
      imageText= {imageText}
      orderDetails= { orderDetails }
      parentSku={parentSku}
    />)
  }

  return (
    <LRItemSection
      parentSku={parentSku}
    >
      <h4>Your Original Order</h4>
      <div>
        <div>
          <div>
            <ImageLoader
              key={Math.random()}
              width="100%"
              height="100%"
              src={imageSrc}
              fit="contain"
              alt={imageText}
              cloudinaryParams="h_125,w_125"
              fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
            />
          </div>
          <div>
            <span>{brandText}</span>
            <span>
              {skuTitle}
            </span>
            <QuantitySelection
              eligibleRMA={eligibleRMA}
              partNumber={partNumber}
              setQtyRange={setQtyRange}
              handleQtyChange={handleQtyChange}
              ikey={0}
              qtyRange={qtyRange}
              qtyToCompute={qtyToCompute}
            />
            <span>
              Unit Price: $
              {parseFloat(itemPriceParsed).toFixed(2)}
            </span>
          </div>
        </div>
        {
          parentSku && (
            <div>
              <div />
              <SetKitDisplay
                parentSku={parentSku}
                showPartNumber={false}
              />
            </div>
          )
        }
      </div>
    </LRItemSection>
  )
}

export default ItemDetail
